import { useTranslation } from "react-i18next";

export default function CustomerSelectCrumb(): string {
  const { t } = useTranslation();
  return t("crumb.SelectCustomer");
}
